import type { SpaceWeeklySchedule } from '../models/Space';

const WEEKDAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] as const;

export function startOfLocalDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function scheduleForCalendarDate(
  schedule: SpaceWeeklySchedule | null | undefined,
  date: Date,
) {
  if (!schedule) return undefined;
  return schedule[WEEKDAY_KEYS[date.getDay()]];
}

/** First open weekday on or after `from`, and not before `today`. */
export function firstOpenDateOnOrAfter(
  schedule: SpaceWeeklySchedule | null | undefined,
  from: Date,
  today: Date = new Date(),
): Date | null {
  if (!schedule) return null;
  const todayStart = startOfLocalDay(today);
  const start = startOfLocalDay(from);
  const cursor = start < todayStart ? todayStart : start;
  for (let i = 0; i < 21; i++) {
    const candidate = new Date(cursor);
    candidate.setDate(cursor.getDate() + i);
    const day = schedule[WEEKDAY_KEYS[candidate.getDay()]];
    if (day && day.dayOff !== true) return candidate;
  }
  return null;
}

export function formatDayMonthYear(date: Date): string {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}/${date.getFullYear()}`;
}
